export default "__VITE_ASSET__fe43862f__"